import React, { useEffect, useState } from 'react';
import styles from 'assets/scss/task_management.module.css';
import { Trans } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';
import { Button } from 'reactstrap';

function ReAssignTask({ task, onClose, availableEmployees, onReassign, t, userPermission }) {
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [reason, setReason] = useState("");
    const [searchKeyword, setSearchKeyword] = useState('');
    const [errors, setErrors] = useState({ employees: "", reason: "" });

    const handleReasonChange = (e) => {
        setReason(e.target.value);
        if (e.target.value.trim() !== "") {
            setErrors({ ...errors, reason: "" });
        }
    };

    const handleReassign = () => {
        let hasError = false;
        const newErrors = { employees: "", reason: "" };

        if (userPermission ===true) {
            if (selectedEmployees?.length === 0) {
                newErrors.employees = "Please select at least one employee.";
                hasError = true;
            }
        }
        if (reason.trim() === "") {
            newErrors.reason = "Please provide a reason for reassignment.";
            hasError = true;
        }

        if (hasError) {
            setErrors(newErrors);
            return;
        }

        onReassign(userPermission !==false ? selectedEmployees : null, reason);
    };

    const handleRemoveEmployee = (employeeId) => {
        setSelectedEmployees(selectedEmployees?.filter(id => id !== employeeId));
    };
    const handleEmployeeSelect = (employeeId) => {
        if (selectedEmployees.includes(employeeId)) {
            setSelectedEmployees(selectedEmployees?.filter(id => id !== employeeId));
        } else {
            setSelectedEmployees([...selectedEmployees, employeeId]);
        }
    };

    return (
            <div className={styles.reassignModalContent}>
                {userPermission ===true && (
                    <div className={styles.formGroup}>
                    <label><Trans>Re-assign to Employees</Trans></label>
                    <div className={styles.dropdownContent}>
                        <div className={styles.notes_area}>
                            <input
                                type="text"
                                placeholder="Search Employees"
                                value={searchKeyword}
                                onChange={(e) => setSearchKeyword(e.target.value)}
                                className={styles.search_employee}
                            />
                        </div>
                        {selectedEmployees?.length > 0 && (
                            <>
                                <div className={styles.assignedEmployees}><strong><Trans>Assigned</Trans></strong></div>
                                {selectedEmployees?.map(employeeId => (
                                    <button key={employeeId} className={styles.assignedEmployee}>
                                        {availableEmployees?.find(employee => employee?.id === employeeId)?.full_name} 
                                        <FaTimes onClick={() => handleRemoveEmployee(employeeId)} />
                                    </button>
                                ))}
                            </>
                        )}
                        <div className={styles.suggestions}><strong><Trans>Suggestions</Trans></strong></div>
                        {availableEmployees
                            ?.filter(employee => !selectedEmployees.includes(employee?.id) && employee?.full_name?.toLowerCase().includes(searchKeyword.toLowerCase()))
                            .map((employee, index) => (
                                <button
                                    key={employee?.id}
                                    className={styles.suggestion}
                                    onClick={() => {
                                        handleEmployeeSelect(employee?.id);
                                        setSearchKeyword("");
                                    }}
                                >
                                    {employee?.full_name}
                                </button>
                            ))}
                    </div>
                    {errors?.employees && <span style={{color:"red"}}>{errors?.employees}</span>}
                </div>
                )}
                <div className={styles.formGroup}>
                    <label><Trans>Reason</Trans>:</label>
                    <textarea value={reason} onChange={handleReasonChange} className={styles.textArea} />
                    {errors?.reason && <span style={{color:"red"}}>{errors?.reason}</span>}
                </div>
                <div className={styles.buttonGroup}>
                    <Button onClick={onClose} color='secondary'><Trans>Cancel</Trans></Button>
                    <Button onClick={handleReassign} color='primary' className=''><Trans>Reassign</Trans></Button>
                </div>
            </div>
    );
}

export default ReAssignTask;
